export default "__VITE_ASSET__2c47a566__"